































































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader, ButtonExport } from '@/components'
import { TableListLoanControls, TableHistoryLoanControl } from '@/components/dailyControl'

// services
import { LoanControlsService } from '@/services/dailyControl'
import { EmployeeService } from '@/services/config'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'

// models
import { FiltersLoanControl, LoanControlForm, LoanControlModel } from '@/models/dailyControl'
import { EmployeeModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditLoanControl from './modalCreateEdit.vue'

const newItem: LoanControlForm = {
  employee_id: null,
  date: '',
  date_start_discount: '',
  amount: 0,
  dues: 0,
  frequency: 1,
  reason: ''
}

@Component({
  name: 'LoanControlsIndex',
  components: {
    PageHeader,
    TableListLoanControls,
    ModalCreateEditLoanControl,
    ButtonExport,
    TableHistoryLoanControl
  }
})
export default class LoanControlsIndex extends Vue {
  showModal = false
  loanControl: LoanControlForm = newItem
  employees: EmployeeModel[] = []
  title = 'Control de Prestamos'
  actionForm = 'save'
  idItemEdit: number|null = null
  modalHistory = false
  loandControls: LoanControlModel[] = []
  loanControlSelected: LoanControlModel|null = null

  filters: FiltersLoanControl = {
    dateStart: null,
    loanDate: null,
    employee: null,
    frequency: null,
    status: null
  }

  items = [
    {
      text: 'Dashboard',
      to: { name: 'home' }
    },
    {
      text: 'Control de Prestamos',
      active: true
    }
  ]

  headersExcel = [
    { text: 'Empleado', value: 'employee' },
    { text: 'Fecha', value: 'date' },
    { text: 'Frecuencia', value: 'frequency' },
    { text: 'Cuotas', value: 'dues' },
    { text: 'Cuotas Gratificación', value: 'cuotasg' },
    { text: 'Importe', value: 'amount' },
    { text: 'Saldo', value: 'balance' },
    { text: 'Estado', value: 'status_text' }
  ]

  get itemsExcel () {
    return this.loandControls.map(item => {
      return {
        ...item,
        employee: getFullNameFormat(item.employee)
      }
    })
  }

  created () {
    this.getAll()
  }

  async getAll () {
    this.employees = await EmployeeService.getActivated()
  }

  async getAllitems () {
    this.loandControls = await LoanControlsService.getAll(this.filters)
  }

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.loanControl = newItem
    this.showModal = true
  }

  showHistory (item: LoanControlModel) {
    this.loanControlSelected = item
    this.modalHistory = true
  }

  async deleteItem (item: LoanControlModel) {
    const msg = `Seguro que desea eliminar el Control de Prestamo del Empleado: ${item.employee.name} ${item.employee.last_name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await LoanControlsService.delete(item.id)
      alerts.success()
      this.tableList.getLoanControlsWithPagination()
      loading('hide')
    }
  }

  get tableList (): Vue & { getLoanControlsWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getLoanControlsWithPagination: () => void }
  }

  get itemInit (): LoanControlForm {
      return newItem
  }
}
